import Vue from 'vue'

import Cookies from 'js-cookie'

import Element from 'element-ui'
import './assets/styles/element-variables.scss'

import '@/assets/styles/index.scss' // global css
import '@/assets/styles/public.scss' // 公共样式
import i18n from './i18n/i18n.js';
import App from './App.vue'
import store from './store'
import router from './router'
import plugins from './plugins' // plugins
import { download } from '@/utils/request'
import { formatDate } from '@/utils/index'

// ... 其他引入
import { showprice } from './utils/index';

// 注册为Vue全局方法
Vue.prototype.$showprice = showprice;
// Vue.prototype.$changelang = changelang;

// 或者注册为全局过滤器
Vue.filter('showprice', showprice);
// Vue.filter('changelang',changelang);
import './permission' // permission control
import './assets/icons' // icon

// 全局方法挂载
Vue.prototype.download = download
Vue.prototype.formatDate = formatDate

// register formatDate as a Vue filter so templates can use `| formatDate(...)`
Vue.filter && Vue.filter('formatDate', formatDate)


Vue.use(plugins)

Vue.config.productionTip = false
Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
})
new Vue({
  router,
  store,
  i18n, //语言切换
  render: h => h(App),
}).$mount('#app')
